import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { IBackendCart } from '@rbi-ctg/menu';
import Currency from 'components/currency';

import { Divider, Total, TotalLabel, TotalsRow } from './modal-order-details.styled';

export const OrderPricesDetails = ({ cart }: { cart: IBackendCart }) => {
  const { formatMessage } = useIntl();
  const { subTotalCents, discounts, donations, taxCents } = cart;

  const discountsAmount = useMemo(() => {
    return discounts?.reduce((acc, { value }) => acc + value, 0) || 0;
  }, [discounts]);

  const donationsAmount = useMemo(() => {
    return donations?.reduce((acc, { totalCents }) => acc + totalCents, 0) || 0;
  }, [donations]);

  return (
    <>
      {/* Subtotal */}
      <TotalsRow>
        <TotalLabel focusable>{formatMessage({ id: 'subtotal' })}</TotalLabel>
        <Total focusable>
          <Currency amount={subTotalCents} />
        </Total>
      </TotalsRow>

      {/* Savings */}
      {discountsAmount > 0 && (
        <TotalsRow>
          <TotalLabel focusable>{formatMessage({ id: 'comboOfferSavings' })}</TotalLabel>
          <Total focusable>
            <Currency amount={discountsAmount} />
          </Total>
        </TotalsRow>
      )}

      {/* Donation */}
      {donationsAmount > 0 && (
        <TotalsRow>
          <TotalLabel focusable>{formatMessage({ id: 'donation' })}</TotalLabel>
          <Total focusable>
            <Currency amount={donationsAmount} />
          </Total>
        </TotalsRow>
      )}

      {/* Taxes */}
      <TotalsRow>
        <TotalLabel focusable>{formatMessage({ id: 'taxes' })}</TotalLabel>
        <Total focusable>
          <Currency amount={taxCents} />
        </Total>
      </TotalsRow>

      <Divider />
    </>
  );
};
